import { render, staticRenderFns } from "./FootBlock.vue?vue&type=template&id=1eab33b2"
import script from "./FootBlock.vue?vue&type=script&lang=js"
export * from "./FootBlock.vue?vue&type=script&lang=js"
import style0 from "./FootBlock.vue?vue&type=style&index=0&id=1eab33b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports